var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValueBgBx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 132,
    viewBox: "0 0 250 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 177.75,
    cy: 171.75,
    r: 177.25,
    stroke: "#778DA9",
    strokeOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.75,
    cy: 171.75,
    r: 153.219,
    stroke: "#778DA9",
    strokeOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.747,
    cy: 171.747,
    r: 125.872,
    stroke: "#778DA9",
    strokeOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.753,
    cy: 171.753,
    r: 98.5262,
    stroke: "#778DA9",
    strokeOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.751,
    cy: 171.751,
    r: 72.0087,
    stroke: "#778DA9",
    strokeOpacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.751,
    cy: 171.751,
    r: 47.9773,
    stroke: "#778DA9",
    strokeOpacity: 0.42
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValueBgBx);
export default __webpack_public_path__ + "static/media/value_bg_bx.a8dea4aa58a9711be147519e0035ded3.svg";
export { ForwardRef as ReactComponent };